<mat-form-field appearance="outline" color="primary" class="containSpinner">
    <mat-label>{{inputLabel | translate}}</mat-label>
    <input matInput disabled/>
    <mat-spinner class="spinnerStyle" [diameter]="20"></mat-spinner>
</mat-form-field>

